<template>
    <label :class="{
        'uik-checkbox__wrapper': true,
        'uik-checkbox__toggle': true,
        'uik-checkbox__toggle--loading': isLoading
    }">
        <input
            :name="name"
            :checked="value"
            :disabled="disabled || isLoading"
            class="uik-checkbox__checkbox"
            type="checkbox"
            @change="$emit('change', !value)"
            @input="$emit('input', !value)"
        >
        <div
            :class="color != '' ? color:''"
            class="uik-checkbox__label">
            <UikLoader
                v-if="isLoading"
                type="dots"
                :size="0.5"
                :color="color ? color:'success'"
            />
            {{ label }}
        </div>
        <p class="uik-checkbox__description">{{ description }}</p>
    </label>
</template>

<script>
export default {
    name: "UikToggle",
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        label: { type: String, default: "" },
        value: { type: [Number, Boolean], default: false },
        description: { type: String, default: "" },
        name: { type: String, default: "" },
        checked: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        color: { type: String, default: "" },
        isLoading: { type: Boolean, default: false },
        emitOnCreate: { type: Boolean, default: false }
    },
    mounted () {
        if (this.checked && this.emitOnCreate) {
            this.$emit("change", true)
        } else if (!this.checked && this.emitOnCreate) {
            this.$emit("change", false)
        }
    }
}
</script>

<style lang="scss">
.uik-checkbox__wrapper.uik-checkbox__toggle {
  .uik-checkbox__description {
    margin-left: 50px;
  }
  .uik-checkbox__label {
    &:before,
    &:after {
      content: '';
      display: block;
      border-radius: 100px;
      transition: .2s;
    }
    &:before {
      width: 38px;
      height: 20px;
      background: $borderColor;
      border: 1px solid $borderColor;
      margin-right: 12px;
    }
    &:after {
      height: 16px;
      width: 16px;
      background: #FFFFFF;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
      position: absolute;
      top: 2px;
      left: 2px;
    }
  }
  .uik-checkbox__checkbox:checked+.uik-checkbox__label {
    &:before {
      background: #34AA44;
      border: 1px solid #2F9E3E;
    }
    &:after {
      transform: translateX(18px);
    }
    @each $name,
    $color in $colors {
      &:global(.#{"" + $name}) {
        &:before {
          background-color: $color;
          border-color: $color;
        }
      }
    }
  }
  .uik-checkbox__checkbox[disabled]+.uik-checkbox__label {
    &:after {
      opacity: 0.6;
    }
  }
}
.uik-checkbox__toggle--loading {
  position: relative;
  .uik-checkbox__label:before, .uik-checkbox__label:after {
    opacity: 0 !important;
  }
  .uik-loader {
    z-index: 1;
    position: absolute;
    top: 0;
    left: -16px;
  }
}
</style>
